import { Component, Input, OnInit } from "@angular/core";
/*
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireObject, AngularFireDatabase } from 'angularfire2/database';
*/
import { Observable } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { TripList } from "../../../models/TripList";
// import { UserList } from '../../../models/UserList';
import { RightinfoService } from "../../../service/rightinfo.service";
import { DriverlistPipe } from "../../../pipes/driverlist.pipe";
import { GlobalSearchPipe } from "../../../pipes/global-search.pipe";
// import { Query } from '@firebase/database';
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import { InfoServiceService } from "../../../service/rightinfo/info-service.service";
import { AppConstants } from "../../../constants/app-constants";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
  trips: Observable<any[]>;
  triplist: TripList[];
  runningTrips: any;
  activePage: 1;
  searchText: string = "";
  nextToken: String = "";

  constructor(
    public awserviceProvider: AwsService,
    // public db: AngularFirestore,
    private router: Router,
    private route: ActivatedRoute,
    private rightinfoService: RightinfoService,
    private infoService: InfoServiceService
  ) {
    infoService.setUrl(AppConstants.HOME_SCREEN);

    this.getTodayTrips();
  }

  getTodayTrips() {
    let dateFormat = require("dateformat");
    let now = new Date();
    // now.setDate(now.getDate() + 1);
    let today = dateFormat(now, "yyyy-mm-dd");

    let current = new Date();
    current.setDate(current.getDate() + 1);
    let tomorrow = dateFormat(current, "yyyy-mm-dd");

    this.awserviceProvider
      .getCurrentDayTripNextToken(today, this.nextToken)
      .then((res: any) => {
        if (res.nextToken != null) {
          this.nextToken = res.nextToken;
          console.log("this.nextToken", this.nextToken);
          this.getTodayTrips();
        }

        let runningList: any = res;
        runningList.forEach((trip) => {
          this.awserviceProvider
            .getUserTripByDriverId(trip.id, trip.driver_id)
            .then((usertrip) => {
              trip.loc = {};
              trip.loc = usertrip[0];
            })
            .catch((err) => {
              console.log(
                "Dashboard : Error in getting User Trip by Trip Id and Driver Id",
                err
              );
            });

          this.awserviceProvider
            .getRncUsers(trip.driver_id)
            .then((driver) => {
              trip.driver = {};
              trip.driver = driver[0];
              this.runningTrips.push(trip);
              this.sortinglist(this.runningTrips);
              this.searchText = "";
            })
            .catch((err) => {
              console.log("Dashboard : Error in getting User Information", err);
            });
        });
      })
      .catch((err) => {
        console.log("Dashboard : Error in getting curretn day trip", err);
      });
  }

  ngOnInit() {
    this.runningTrips = [];
    this.searchText = "";
  }

  sortinglist(tripList) {
    const sorted = tripList.sort((t1, t2) => {
      const date1 = t1.scheduled_date;
      const date2 = t2.scheduled_date;
      var start = new Date(date1).getTime();
      var end = new Date(date2).getTime();
      //console.log("start", date1)
      //console.log("end", date2)
      //console.log("start > end", start > end)
      //console.log("start > end", start < end)
      if (start > end) {
        return -1;
      }
      if (start < end) {
        return 1;
      }
      return 0;
    });

    return sorted;
  }
}
